import ErrorPage from '@/pages/ErrorPage';
import GameDetailPage from '@/pages/GameDetailPage';
import HomePage from '@/pages/HomePage';
import Layout from '@/pages/Layout';
import { createBrowserRouter } from 'react-router';

const router = createBrowserRouter([
	{
		path: '/',
		errorElement: <Layout errorElement={<ErrorPage />} />, // Pass ErrorPage to Layout
		element: <Layout />,
		children: [
			{ index: true, element: <HomePage /> },
			{ path: 'games/:slug', element: <GameDetailPage /> }
		]
	}
]);

export default router;
